class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}
document.addEventListener('submit', function(event) {
  const form = event.target;

  if (!form.matches('form[action="/search"]')) return;

  const input = form.querySelector('input[name="q"]');
  if (!input) return;

  const searchSwaps = {
    'stitch': 'blue alien',
    'lilo and stitch': 'blue alien',
    'lego': 'building blocks',
    'barbie': 'doll',
    'winnie the pooh': 'bear',
    'spiderman': 'superhero',
    'batman': 'superhero',
    'marvel': 'superhero',
    'rangers': 'football',
    'celtic': 'football',
    'liverpool': 'football',
    'man city': 'football',
    'man united': 'football',
    'minecraft': 'pixel gaming',
    'teletubbies': 'colourful characters',
    'giants': 'ice hockey',
    'taylor swift': 'singer',
    'coco melon': 'cartoon',
    'mario': 'arcade gaming',
    'hello kitty': 'cat',
    'peppa pig': 'pig',
    'spongebob': 'sea cartoon',
    'mickey mouse': 'mouse',
    'bluey': 'blue puppy',
    'wwe': 'wrestling',
    'guinness': 'stout'
  };

  const searched = input.value.trim().toLowerCase();

  if (searchSwaps[searched]) {
    input.value = searchSwaps[searched];
  }
});
customElements.define('search-form', SearchForm);
